import cx from 'classnames';
import {
  Nav as BootstrapNav,
  Tab as BootstrapTab,
  NavLinkProps,
  NavProps,
} from 'react-bootstrap';
import css from './Tab.module.scss';

const Item = ({ children, className, eventKey, ...rest }: NavLinkProps) => (
  <BootstrapNav.Item>
    <BootstrapNav.Link
      className={cx(css.link, className)}
      eventKey={eventKey}
      {...rest}
    >
      {children}
    </BootstrapNav.Link>
  </BootstrapNav.Item>
);

const Nav = ({ children, className, ...rest }: NavProps) => (
  <BootstrapNav className={className} {...rest}>
    {children}
  </BootstrapNav>
);

/* @deprecated */
export const Tab = {
  ...BootstrapTab,
  Item,
  Nav,
};
